import axios from 'axios';

const state = {
    cart: null,
    user: null,
    paymentType: null,
};

const getters = {
    canSubmit: state => {
        if (state.cart.amountOwedByStudent <= 0) {
            return true;
        }
        if (state.cart.hasShipping && state.cart.needsShipping) {
            return false;
        }
        if (state.user.needsAddress) {
            return false;
        }
        return true;
    },
};

const actions = {
    setCart({ commit }, cart) {
        commit('setCart', cart);
    },

    setUser({ commit }, user) {
        commit('setUser', user);
    },
    async addProduct({commit, state}, {sku, suggestionId}) {
        await axios.get(`/Cart/add?sku=${sku}&suggestion=${suggestionId}`);
        const { data } = await axios.put(`/api/cart/${state.cart.cartId}/tax`);
        commit('setCart', data);
    },
    async deleteProduct({commit, state}, {sku, suggestionId}) {
        const { data:cart } = await axios.get(`/Cart/remove?sku=${sku}&suggestion=${suggestionId}`);
        if (cart.items.length > 0) {
            const {data} = await axios.put(`/api/cart/${state.cart.cartId}/tax`);
            commit('setCart', data);
        }else {
            commit('setCart', cart);
        }
    },
    async addPaymentPlan({ commit, state }) {
        await axios.post(`/api/cart/${state.cart.cartId}/payment-plan`);
        const { data } = await axios.put(`/api/cart/${state.cartId}/tax`);
        commit('setCart', data);
    },

    async deletePaymentPlan({ commit, state }) {
        await axios.delete(`/api/cart/${state.cart.cartId}/payment-plan`);
        const { data } = await axios.put(`/api/cart/${state.cartId}/tax`);
        commit('setCart', data);
    },

    async addCode({ commit, state }, {orgCode, tzOffset}) {
        try {
            await axios.post(`/api/cart/${state.cart.cartId}/org-code`, {
                orgCode: orgCode,
                tzOffset: tzOffset
            });
            const { data } = await axios.put(`/api/cart/${state.cartId}/tax`);

            commit('setCart', data);
        }catch(e) {
            throw e;
        }
    },

    async deleteCode({ commit, state }) {
        await axios.delete(`/api/cart/${state.cart.cartId}/org-code`);
        const { data } = await axios.put(`/api/cart/${state}.cartId}/tax`);
        commit('setCart', data);
    },

    setPaymentType({ commit}, type) {
        commit('setPaymentType', type)
    }
};

const mutations = {
    setCart (state, cart) {
        state.cart = cart;
    },

    setUser (state, user) {
        state.user = user;
    },

    setPaymentType(state, type) {
        state.paymentType = type;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}